import 'swiper/dist/css/swiper.css'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n'
import raf from './plugins/raf'
import api from './plugins/api'
import scroll from './plugins/scroll'
import tools from './plugins/tools'
import parallax from './plugins/parallax'
import metatag from './plugins/metatag'
import VueCookie from 'vue-cookie'
import VueAnalytics from 'vue-analytics'
import InstantSearch from 'vue-instantsearch'
import VueLazyload from 'vue-lazyload'
import './filters'
import {TweenLite, Power4} from 'gsap'
import { VueHammer } from 'vue2-hammer'
import * as VueGoogleMaps from 'vue2-google-maps'
import Autocomplete from 'v-autocomplete'
import 'v-autocomplete/dist/v-autocomplete.css'
import 'babel-polyfill'
import Es6Promise from 'es6-promise'
Es6Promise.polyfill()

// Configure GSAP
// default ease
TweenLite.defaultEase = Power4.easeOut

Vue.config.productionTip = false

Vue.use(InstantSearch)
Vue.use(VueCookie)
Vue.use(api)
Vue.use(raf)
Vue.use(tools)
Vue.use(parallax)
Vue.use(metatag)
Vue.use(VueHammer)
Vue.use(VueAwesomeSwiper)
Vue.use(scroll)
Vue.use(Autocomplete)

Vue.use(VueLazyload, {
  preLoad: 3,
  attempt: 1
})

Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GOOGLE_MAPS_KEY,
    libraries: 'places' // necessary for places input
  }
})

Vue.use(VueAnalytics, {
  id: process.env.VUE_APP_GOOGLE_ANALYTICS,
  router
})

// Guards router
router.beforeEach((to, from, next) => {
  // Seulement si on est pas déjà en pleine transition de page
  if (!store.state.isPageTransitioning) {
    // Au cas où, si le menu est ouvert
    if (store.state.menuOpened) {
      // On le referme
      store.dispatch('setMenuOpen', false)
    }

    next()
  }
})

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
